import * as yup from "yup";

import { t } from "@/i18n-js/instance";

export const validationSchema = yup.object().shape({
  paywall_id: yup
    .number()
    .nullable()
    .required(() => t("settings.validation.this_field_is_required")),
  title: yup
    .string()
    .nullable()
    .required(() => t("settings.validation.this_field_is_required")),
  description: yup
    .string()
    .nullable()
    .required(() => t("settings.validation.this_field_is_required")),
  button_text: yup
    .string()
    .nullable()
    .required(() => t("settings.validation.this_field_is_required")),
});
